import React, { createContext, useContext, useEffect, useState } from 'react';
type ThemeContextType = {
  isDark: boolean;
  toggleTheme: () => void;
};
const ThemeContext = createContext<ThemeContextType>({
  isDark: false,
  toggleTheme: () => {}
});
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isDark, setIsDark] = useState(false);
  useEffect(() => {
    const root = window.document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [isDark]);
  const toggleTheme = () => setIsDark(!isDark);
  return <ThemeContext.Provider value={{
    isDark,
    toggleTheme
  }} data-id="element-518" data-mp="3mwmgvta96ksh">
      {children}
    </ThemeContext.Provider>;
}
export const useTheme = () => useContext(ThemeContext);